import { ConfigProvider, Segmented } from "antd";

const ToggleButton = ({
  options = [],
  className = "",
  onChange,
  defaultValue,
  value,
  block = false,
}) => {
  // If a controlled `value` is provided, hand it to Segmented so the highlight
  // tracks parent state. Otherwise fall back to uncontrolled `defaultValue`.
  const segmentedProps = value !== undefined ? { value } : { defaultValue };

  return (
    <ConfigProvider
      theme={{
        components: {
          Segmented: {
            itemSelectedBg: "var(--accent-color)",
            itemSelectedColor: "#fff",
            itemColor: "var(--text-main)",
            bgColor: "var(--card-bg)",
          },
        },
      }}
    >
      <Segmented
        {...segmentedProps}
        options={options}
        className={`p-1 border rounded-3 ${className}`}
        style={{ backgroundColor: "var(--card-bg)" }}
        onChange={onChange}
        block={block}
      />
    </ConfigProvider>
  );
};

export default ToggleButton;
